import React from 'react';
import DataTable from '../DataTable';
import EditForm from '../main/EditForm';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import Tasks from '../tasks/Tasks';
import { getProfileFromLocalStorage } from '../../helpers/session';

const contractIgnoreFields = ['mostRecentComment', 'Comments', 'Optional Equipment And Accessories', 'tasks'];

const ContractInfoSideBar = ({
  sidebarMode,
  onContractInfoSideBarHide,
  contract,
  appChoices,
  onContractEdit,
  onContractDelete
}) => {
  const currentUserId = getProfileFromLocalStorage()?._id;

  return (
    <SlidingSideBar
      fullScreen
      visible={sidebarMode !== null}
      onClose={onContractInfoSideBarHide}
      title={'Contract Details'}
    >
      {contract && sidebarMode !== null && (
        <>
          {sidebarMode === 'view' ? (
            <>
              <DataTable data={contract} ignoreFields={contractIgnoreFields} />
              {contract.tasks && contract.tasks.length > 0 && (
                <div className="mt-4">
                  <Tasks
                    tasks={contract.tasks}
                    disabled={true}
                    appChoices={appChoices}
                    currentUserId={currentUserId}
                  />
                </div>
              )}
            </>
          ) : (
            <EditForm
              contractFromSearch={contract}
              appChoices={appChoices}
              fromSearch
              onContractDelete={onContractDelete}
              onContractEdit={onContractEdit}
            />
          )}
        </>
      )}
    </SlidingSideBar>
  );
};

export default ContractInfoSideBar;
